import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const categoryImporterSelectors = importerSelectors(
  'category.importer',
)

export default categoryImporterSelectors
